const APP = {
  routes: {
    home: 'home',
    about: 'about',
  },
};

export default APP;
